import React, { useState, useEffect, PropTypes } from "react"
import SearchResultInputBox from '../predictive-search/SearchResultBox';
import { Col, Container, Row, Form, Button } from 'react-bootstrap';
import { navigate } from "@reach/router"
import Select from 'react-select';
import {
  connectRefinementList
} from "react-instantsearch-dom"
import $ from "jquery";
import _ from "lodash"


const styles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#005480" : null,
      color: isFocused ? "#ffffff" : "#575757"
    };
  },
  control: styles => ({
    ...styles,
    backgroundColor: null,
    border: 0,
    paddingLeft: 0,
    outline: 0,
    boxShadow: 'none',
    color: '#4c505b',
    fontSize: '1rem',
    fontWeight: '300'
  }),
  valueContainer: (styles) => ({
    ...styles,
    fontSize: '1rem',
    paddingLeft: '10px',
    paddingRight: 0,
    lineHeight: '30px',
    fontWeight: '300',
    cursor: 'pointer'
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    //  color: "#ffffff",
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    // color: '#ffffff',
    padding: 0,
    cursor: 'pointer'
  }),
  indicatorSeparator: () => null,
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: '#4c505b',
      marginLeft: 0
    }
  },
}

// Capitalize
const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
// Capitalize

const CustomRefinementList = (({ setAmenities, amenities, amenitiesList }) => {
 
  // let amenitesList = items;
  amenitiesList.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));

  return (
    <div className="amenities-refine">
      {
        amenitiesList.length > 0 ? <div className="refine-heading">Amenities</div> : ''
      }
      <ul className="refine-search-left">
        {amenitiesList.map(item => (
          <li key={item.label}>
            <label className="refine-check-wrapper">


              <input type="checkbox"
                defaultChecked={amenities.includes(item.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    //item.isRefineNotChecked = false
                    amenities.push(item.value)
                  } else {
                    //item.isRefined = false;  
                    amenities = amenities.filter(e => e !== item.label)
                  }
                  setAmenities(amenities)
                  // refine(item.value) 
                }} />
              {capitalize(item.label.replace(/-/g, ' '))}
              <span className="refine-checkmark"></span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
})



const SearchFilter = (props) => {
  const [filterOpen, setFilterOpen] = useState(false);
  const [areaVal, setAreaVal] = useState('');
  const [minpriceVal, setMinPriceVal] = useState('');
  const [minpricelabel, setMinpricelabel] = useState('');
  const [maxpricelabel, setMaxpricelabel] = useState('');
  const [maxpriceVal, setMaxPriceVal] = useState('');
  const [propertyval, setPropertyVal] = useState(null);
  const [bedVal, setBedVal] = useState('');
  const [minPriceList, setMinPriceList] = useState([]);
  const [maxPriceList, setMaxPriceList] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [sqftMin, setSqftMin] = useState(0);
  const [sqftMax, setSqftMax] = useState(0);

  var area = "";
  const options = [
    { value: "0", label: "Any" },
    { value: '1', label: '1 +' },
    { value: '2', label: '2 +' },
    { value: '3', label: '3 +' },
    { value: '4', label: '4 +' },
    { value: '5', label: '5 +' },
    { value: '6', label: '6 +' },
    { value: '7', label: '7 +' },
    { value: '8', label: '8 +' },
    { value: '9', label: '9 +' }
  ]
  const propertytypelist = [
    { value: "", label: "All" },
    { value: "apartment", label: "Apartments" },
    { value: "villa", label: "Villas" },
    { value: "townhouse", label: "Townhouses" },
    { value: "penthouse", label: "Penthouses" },
    { value: "land", label: "Lands" },
    { value: "plot", label: "Plots" },
    { value: "full-floor", label: "Full floors" },
    { value: "duplex", label: "Duplexes" },
    { value: "whole-building", label: "Whole Building" },
    { value: "hotel-apartment", label: "Hotel/Hotel Apartments" },
    // { value: "semi-detached-house", label: "Semi Detached House" }
  ]
  // Min Price
  const [selectedMinPriceValue, setSelectedMinPriceValue] = useState(0);
  const [selectedMaxPriceValue, setSelectedMaxPriceValue] = useState(0);

  // AED  Lettings min and max
  const priceminRangeLettings = [{ "value": "0", "label": "No Min" }, { "value": "20000", "label": "20,000 AED" }, { "value": "30000", "label": "30,000 AED" }, { "value": "40000", "label": "40,000 AED" }, { "value": "50000", "label": "50,000 AED" }, { "value": "60000", "label": "60,000 AED" }, { "value": "70000", "label": "70,000 AED" }, { "value": "80000", "label": "80,000 AED" }, { "value": "90000", "label": "90,000 AED" }, { "value": "100000", "label": "100,000 AED" }, { "value": "110000", "label": "110,000 AED" }, { "value": "120000", "label": "120,000 AED" }, { "value": "130000", "label": "130,000 AED" }, { "value": "140000", "label": "140,000 AED" }, { "value": "150000", "label": "150,000 AED" }, { "value": "160000", "label": "160,000 AED" }, { "value": "170000", "label": "170,000 AED" }, { "value": "180000", "label": "180,000 AED" }, { "value": "190000", "label": "190,000 AED" }, { "value": "200000", "label": "200,000 AED" }, { "value": "225000", "label": "225,000 AED" }, { "value": "250000", "label": "250,000 AED" }, { "value": "275000", "label": "275,000 AED" }, { "value": "300000", "label": "300,000 AED" }, { "value": "350000", "label": "350,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "750000", "label": "750,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }]
  const pricemaxRangeLettings = [{ "value": "0", "label": "No Max" }, { "value": "20000", "label": "20,000 AED" }, { "value": "30000", "label": "30,000 AED" }, { "value": "40000", "label": "40,000 AED" }, { "value": "50000", "label": "50,000 AED" }, { "value": "60000", "label": "60,000 AED" }, { "value": "70000", "label": "70,000 AED" }, { "value": "80000", "label": "80,000 AED" }, { "value": "90000", "label": "90,000 AED" }, { "value": "100000", "label": "100,000 AED" }, { "value": "110000", "label": "110,000 AED" }, { "value": "120000", "label": "120,000 AED" }, { "value": "130000", "label": "130,000 AED" }, { "value": "140000", "label": "140,000 AED" }, { "value": "150000", "label": "150,000 AED" }, { "value": "160000", "label": "160,000 AED" }, { "value": "170000", "label": "170,000 AED" }, { "value": "180000", "label": "180,000 AED" }, { "value": "190000", "label": "190,000 AED" }, { "value": "200000", "label": "200,000 AED" }, { "value": "225000", "label": "225,000 AED" }, { "value": "250000", "label": "250,000 AED" }, { "value": "275000", "label": "275,000 AED" }, { "value": "300000", "label": "300,000 AED" }, { "value": "350000", "label": "350,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "750000", "label": "750,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }]

  // Sales min and max
  const priceminRange = [{ "value": "0", "label": "No Min" }, { "value": "300000", "label": "300,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "600000", "label": "600,000 AED" }, { "value": "700000", "label": "700,000 AED" }, { "value": "800000", "label": "800,000 AED" }, { "value": "900000", "label": "900,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }, { "value": "1100000", "label": "1,100,000 AED" }, { "value": "1200000", "label": "1,200,000 AED" }, { "value": "1300000", "label": "1,300,000 AED" }, { "value": "1400000", "label": "1,400,000 AED" }, { "value": "1500000", "label": "1,500,000 AED" }, { "value": "1600000", "label": "1,650,000 AED" }, { "value": "1700000", "label": "1,700,000 AED" }, { "value": "1800000", "label": "1,800,000 AED" }, { "value": "1900000", "label": "1,900,000 AED" }, { "value": "2000000", "label": "2,000,000 AED" }, { "value": "2100000", "label": "2,100,000 AED" }, { "value": "2200000", "label": "2,200,000 AED" }, { "value": "2300000", "label": "2,300,000 AED" }, { "value": "2400000", "label": "2,400,000 AED" }, { "value": "2500000", "label": "2,500,000 AED" }, { "value": "2600000", "label": "2,600,000 AED" }, { "value": "2700000", "label": "2,700,000 AED" }, { "value": "2800000", "label": "2,800,000 AED" }, { "value": "2900000", "label": "2,900,000 AED" }, { "value": "3000000", "label": "3,000,000 AED" }, { "value": "3250000", "label": "3,250,000 AED" }, { "value": "3500000", "label": "3,500,000 AED" }, { "value": "3750000", "label": "3,750,000 AED" }, { "value": "4000000", "label": "4,000,000 AED" }, { "value": "4250000", "label": "4,250,000 AED" }, { "value": "4500000", "label": "4,500,000 AED" }, { "value": "5000000", "label": "5,000,000 AED" }, { "value": "6000000", "label": "6,000,000 AED" }, { "value": "7000000", "label": "7,000,000 AED" }, { "value": "8000000", "label": "8,000,000 AED" }, { "value": "9000000", "label": "9,000,000 AED" }, { "value": "10000000", "label": "10,000,000 AED" }, { "value": "25000000", "label": "25,000,000 AED" }, { "value": "50000000", "label": "50,000,000 AED" }]
  const pricemaxRange = [{ "value": "0", "label": "No Max" }, { "value": "300000", "label": "300,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "600000", "label": "600,000 AED" }, { "value": "700000", "label": "700,000 AED" }, { "value": "800000", "label": "800,000 AED" }, { "value": "900000", "label": "900,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }, { "value": "1100000", "label": "1,100,000 AED" }, { "value": "1200000", "label": "1,200,000 AED" }, { "value": "1300000", "label": "1,300,000 AED" }, { "value": "1400000", "label": "1,400,000 AED" }, { "value": "1500000", "label": "1,500,000 AED" }, { "value": "1600000", "label": "1,650,000 AED" }, { "value": "1700000", "label": "1,700,000 AED" }, { "value": "1800000", "label": "1,800,000 AED" }, { "value": "1900000", "label": "1,900,000 AED" }, { "value": "2000000", "label": "2,000,000 AED" }, { "value": "2100000", "label": "2,100,000 AED" }, { "value": "2200000", "label": "2,200,000 AED" }, { "value": "2300000", "label": "2,300,000 AED" }, { "value": "2400000", "label": "2,400,000 AED" }, { "value": "2500000", "label": "2,500,000 AED" }, { "value": "2600000", "label": "2,600,000 AED" }, { "value": "2700000", "label": "2,700,000 AED" }, { "value": "2800000", "label": "2,800,000 AED" }, { "value": "2900000", "label": "2,900,000 AED" }, { "value": "3000000", "label": "3,000,000 AED" }, { "value": "3250000", "label": "3,250,000 AED" }, { "value": "3500000", "label": "3,500,000 AED" }, { "value": "3750000", "label": "3,750,000 AED" }, { "value": "4000000", "label": "4,000,000 AED" }, { "value": "4250000", "label": "4,250,000 AED" }, { "value": "4500000", "label": "4,500,000 AED" }, { "value": "5000000", "label": "5,000,000 AED" }, { "value": "6000000", "label": "6,000,000 AED" }, { "value": "7000000", "label": "7,000,000 AED" }, { "value": "8000000", "label": "8,000,000 AED" }, { "value": "9000000", "label": "9,000,000 AED" }, { "value": "10000000", "label": "10,000,000 AED" }, { "value": "25000000", "label": "25,000,000 AED" }, { "value": "50000000", "label": "50,000,000 AED" }]

  // GBP Lettings min and max

  const lettingsminGBP = [{ "value": "0", "label": "No Min" }, { "value": "20000", "label": "4,000 GBP" }, { "value": "30000", "label": "6,000 GBP" }, { "value": "40000", "label": "8,000 GBP" }, { "value": "50000", "label": "10,000 GBP" }, { "value": "60000", "label": "12,000 GBP" }, { "value": "70000", "label": "14,000 GBP" }, { "value": "80000", "label": "16,000 GBP" }, { "value": "90000", "label": "18,000 GBP" }, { "value": "100000", "label": "20,000 GBP" }, { "value": "110000", "label": "22,000 GBP" }, { "value": "120000", "label": "24,000 GBP" }, { "value": "130000", "label": "26,000 GBP" }, { "value": "140000", "label": "28,000 GBP" }, { "value": "150000", "label": "30,000 GBP" }, { "value": "160000", "label": "32,000 GBP" }, { "value": "170000", "label": "34,000 GBP" }, { "value": "180000", "label": "36,000 GBP" }, { "value": "190000", "label": "38,000 GBP" }, { "value": "200000", "label": "40,000 GBP" }, { "value": "225000", "label": "55,000 GBP" }, { "value": "250000", "label": "60,000 GBP" }, { "value": "275000", "label": "65,000 GBP" }, { "value": "300000", "label": "70,000 GBP" }, { "value": "350000", "label": "85,000 GBP" }, { "value": "400000", "label": "100,000 GBP" }, { "value": "500000", "label": "120,000 GBP" }, { "value": "750000", "label": "180,000 GBP" }, { "value": "1000000", "label": "200,000 GBP" }]
  const lettingsmaxGBP = [{ "value": "0", "label": "No Max" }, { "value": "20000", "label": "20,000 GBP" }, { "value": "30000", "label": "30,000 GBP" }, { "value": "40000", "label": "40,000 GBP" }, { "value": "50000", "label": "50,000 GBP" }, { "value": "60000", "label": "60,000 GBP" }, { "value": "70000", "label": "70,000 GBP" }, { "value": "80000", "label": "80,000 GBP" }, { "value": "90000", "label": "90,000 GBP" }, { "value": "100000", "label": "100,000 GBP" }, { "value": "110000", "label": "110,000 GBP" }, { "value": "120000", "label": "120,000 GBP" }, { "value": "130000", "label": "130,000 GBP" }, { "value": "140000", "label": "140,000 GBP" }, { "value": "150000", "label": "150,000 GBP" }, { "value": "160000", "label": "160,000 GBP" }, { "value": "170000", "label": "170,000 GBP" }, { "value": "180000", "label": "180,000 GBP" }, { "value": "190000", "label": "190,000 GBP" }, { "value": "200000", "label": "200,000 GBP" }, { "value": "225000", "label": "225,000 GBP" }, { "value": "250000", "label": "250,000 GBP" }, { "value": "275000", "label": "275,000 GBP" }, { "value": "300000", "label": "300,000 GBP" }, { "value": "350000", "label": "350,000 GBP" }, { "value": "400000", "label": "400,000 GBP" }, { "value": "500000", "label": "500,000 GBP" }, { "value": "750000", "label": "750,000 GBP" }, { "value": "1000000", "label": "1,000,000 GBP" }]

  // Sales min and max
  const salesminGBP = [{ "value": "0", "label": "No Min" }, { "value": "300000", "label": "70,000 GBP" }, { "value": "400000", "label": "90,000 GBP" }, { "value": "500000", "label": "120,000 GBP" }, { "value": "600000", "label": "140,000 GBP" }, { "value": "700000", "label": "160,000 GBP" }, { "value": "800000", "label": "190,000 GBP" }, { "value": "900000", "label": "210,000 GBP" }, { "value": "1000000", "label": "240,000 GBP" }, { "value": "1100000", "label": "260,000 GBP" }, { "value": "1200000", "label": "280,000 GBP" }, { "value": "1300000", "label": "300,000 GBP" }, { "value": "1400000", "label": "320,000 GBP" }, { "value": "1500000", "label": "340,000 GBP" }, { "value": "1600000", "label": "360,000 GBP" }, { "value": "1700000", "label": "380,000 GBP" }, { "value": "1800000", "label": "400,000 GBP" }, { "value": "1900000", "label": "420,000 GBP" }, { "value": "2000000", "label": "440,000 GBP" }, { "value": "2100000", "label": "460,000 GBP" }, { "value": "2200000", "label": "480,000 GBP" }, { "value": "2300000", "label": "500,000 GBP" }, { "value": "2400000", "label": "520,000 GBP" }, { "value": "2500000", "label": "540,000 GBP" }, { "value": "2600000", "label": "560,000 GBP" }, { "value": "2700000", "label": "580,000 GBP" }, { "value": "2800000", "label": "600,000 GBP" }, { "value": "2900000", "label": "620,000 GBP" }, { "value": "3000000", "label": "640,000 GBP" }, { "value": "3250000", "label": "780,000 GBP" }, { "value": "3500000", "label": "850,000 GBP" }, { "value": "3750000", "label": "910,000 GBP" }, { "value": "4000000", "label": "970,000 GBP" }, { "value": "4250000", "label": "1,003,000 GBP" }, { "value": "4500000", "label": "1,009,000 GBP" }, { "value": "5000000", "label": "1,015,000 GBP" }, { "value": "6000000", "label": "1,040,000 GBP" }, { "value": "7000000", "label": "1,065,000 GBP" }, { "value": "8000000", "label": "1,095,000 GBP" }, { "value": "9000000", "label": "1,125,000 GBP" }, { "value": "10000000", "label": "1,150,000 GBP" }, { "value": "25000000", "label": "6,000,000 GBP" }, { "value": "50000000", "label": "12,000,000 GBP" }]
  const salesmaxGBP = [{ "value": "0", "label": "No Max" }, { "value": "300000", "label": "70,000 GBP" }, { "value": "400000", "label": "90,000 GBP" }, { "value": "500000", "label": "120,000 GBP" }, { "value": "600000", "label": "140,000 GBP" }, { "value": "700000", "label": "160,000 GBP" }, { "value": "800000", "label": "190,000 GBP" }, { "value": "900000", "label": "210,000 GBP" }, { "value": "1000000", "label": "240,000 GBP" }, { "value": "1100000", "label": "260,000 GBP" }, { "value": "1200000", "label": "280,000 GBP" }, { "value": "1300000", "label": "300,000 GBP" }, { "value": "1400000", "label": "320,000 GBP" }, { "value": "1500000", "label": "1,500,000 GBP" }, { "value": "1600000", "label": "1,650,000 GBP" }, { "value": "1700000", "label": "1,700,000 GBP" }, { "value": "1800000", "label": "1,800,000 GBP" }, { "value": "1900000", "label": "1,900,000 GBP" }, { "value": "2000000", "label": "2,000,000 GBP" }, { "value": "2100000", "label": "2,100,000 GBP" }, { "value": "2200000", "label": "2,200,000 GBP" }, { "value": "2300000", "label": "2,300,000 GBP" }, { "value": "2400000", "label": "2,400,000 GBP" }, { "value": "2500000", "label": "2,500,000 GBP" }, { "value": "2600000", "label": "2,600,000 GBP" }, { "value": "2700000", "label": "2,700,000 GBP" }, { "value": "2800000", "label": "2,800,000 GBP" }, { "value": "2900000", "label": "2,900,000 GBP" }, { "value": "3000000", "label": "3,000,000 GBP" }, { "value": "3250000", "label": "3,250,000 GBP" }, { "value": "3500000", "label": "3,500,000 GBP" }, { "value": "3750000", "label": "3,750,000 GBP" }, { "value": "4000000", "label": "4,000,000 GBP" }, { "value": "4250000", "label": "4,250,000 GBP" }, { "value": "4500000", "label": "4,500,000 GBP" }, { "value": "5000000", "label": "5,000,000 GBP" }, { "value": "6000000", "label": "6,000,000 GBP" }, { "value": "7000000", "label": "7,000,000 GBP" }, { "value": "8000000", "label": "8,000,000 GBP" }, { "value": "9000000", "label": "9,000,000 GBP" }, { "value": "10000000", "label": "10,000,000 GBP" }, { "value": "25000000", "label": "25,000,000 GBP" }, { "value": "50000000", "label": "50,000,000 GBP" }]

  // EUR Lettings min and max

  const lettingsminEUR = [{ "value": "0", "label": "No Min" }, { "value": "20000", "label": "5,000 EUR" }, { "value": "30000", "label": "7,500 EUR" }, { "value": "40000", "label": "10,000 EUR" }, { "value": "50000", "label": "12,500 EUR" }, { "value": "60000", "label": "15,000 EUR" }, { "value": "70000", "label": "17,500 EUR" }, { "value": "80000", "label": "20,000 EUR" }, { "value": "90000", "label": "22,500 EUR" }, { "value": "100000", "label": "25,000 EUR" }, { "value": "110000", "label": "27,500 EUR" }, { "value": "120000", "label": "30,000 EUR" }, { "value": "130000", "label": "32,500 EUR" }, { "value": "140000", "label": "35,000 EUR" }, { "value": "150000", "label": "37,500 EUR" }, { "value": "160000", "label": "40,000 EUR" }, { "value": "170000", "label": "42,500 EUR" }, { "value": "180000", "label": "45,000 EUR" }, { "value": "190000", "label": "50,000 EUR" }, { "value": "200000", "label": "52,500 EUR" }, { "value": "225000", "label": "60,000 EUR" }, { "value": "250000", "label": "65,000 EUR" }, { "value": "275000", "label": "70,000 EUR" }, { "value": "300000", "label": "75,000 EUR" }, { "value": "350000", "label": "80,000 EUR" }, { "value": "400000", "label": "100,000 EUR" }, { "value": "500000", "label": "125,000 EUR" }, { "value": "750000", "label": "180,000 EUR" }, { "value": "1000000", "label": "250,000 EUR" }]
  const lettingsmaxEUR = [{ "value": "0", "label": "No Max" }, { "value": "20000", "label": "5,000 EUR" }, { "value": "30000", "label": "7,500 EUR" }, { "value": "40000", "label": "10,000 EUR" }, { "value": "50000", "label": "12,500 EUR" }, { "value": "60000", "label": "15,000 EUR" }, { "value": "70000", "label": "17,500 EUR" }, { "value": "80000", "label": "20,000 EUR" }, { "value": "90000", "label": "22,500 EUR" }, { "value": "100000", "label": "25,000 EUR" }, { "value": "110000", "label": "27,500 EUR" }, { "value": "120000", "label": "30,000 EUR" }, { "value": "130000", "label": "32,500 EUR" }, { "value": "140000", "label": "35,000 EUR" }, { "value": "150000", "label": "37,500 EUR" }, { "value": "160000", "label": "40,000 EUR" }, { "value": "170000", "label": "42,500 EUR" }, { "value": "180000", "label": "45,000 EUR" }, { "value": "190000", "label": "50,000 EUR" }, { "value": "200000", "label": "52,500 EUR" }, { "value": "225000", "label": "60,000 EUR" }, { "value": "250000", "label": "65,000 EUR" }, { "value": "275000", "label": "70,000 EUR" }, { "value": "300000", "label": "75,000 EUR" }, { "value": "350000", "label": "80,000 EUR" }, { "value": "400000", "label": "100,000 EUR" }, { "value": "500000", "label": "125,000 EUR" }, { "value": "750000", "label": "180,000 EUR" }, { "value": "1000000", "label": "250,000 EUR" }]

  // Sales min and max
  const salesminEUR = [{ "value": "0", "label": "No Min" }, { "value": "300000", "label": "80,000 EUR" }, { "value": "400000", "label": "100,000 EUR" }, { "value": "500000", "label": "125,000 EUR" }, { "value": "600000", "label": "150,000 EUR" }, { "value": "700000", "label": "180,000 EUR" }, { "value": "800000", "label": "200,000 EUR" }, { "value": "900000", "label": "225,000 EUR" }, { "value": "1000000", "label": "260,000 EUR" }, { "value": "1100000", "label": "285,000 EUR" }, { "value": "1200000", "label": "310,000 EUR" }, { "value": "1300000", "label": "335,000 EUR" }, { "value": "1400000", "label": "360,000 EUR" }, { "value": "1500000", "label": "385,000 EUR" }, { "value": "1600000", "label": "410,000 EUR" }, { "value": "1700000", "label": "430,000 EUR" }, { "value": "1800000", "label": "450,000 EUR" }, { "value": "1900000", "label": "480,000 EUR" }, { "value": "2000000", "label": "500,000 EUR" }, { "value": "2100000", "label": "550,000 EUR" }, { "value": "2200000", "label": "600,000 EUR" }, { "value": "2300000", "label": "630,000 EUR" }, { "value": "2400000", "label": "660,000 EUR" }, { "value": "2500000", "label": "690,000 EUR" }, { "value": "2600000", "label": "710,000 EUR" }, { "value": "2700000", "label": "750,000 EUR" }, { "value": "2800000", "label": "780,000 EUR" }, { "value": "2900000", "label": "810,000 EUR" }, { "value": "3000000", "label": "850,000 EUR" }, { "value": "3250000", "label": "880,000 EUR" }, { "value": "3500000", "label": "910,000 EUR" }, { "value": "3750000", "label": "950,000 EUR" }, { "value": "4000000", "label": "980,000 EUR" }, { "value": "4250000", "label": "1,10,000 EUR" }, { "value": "4500000", "label": "1,250,000 EUR" }, { "value": "5000000", "label": "1,350,000 EUR" }, { "value": "6000000", "label": "1,650,000 EUR" }, { "value": "7000000", "label": "1,900,000 EUR" }, { "value": "8000000", "label": "2,200,000 EUR" }, { "value": "9000000", "label": "2,500,000 EUR" }, { "value": "10000000", "label": "2,700,000 EUR" }, { "value": "25000000", "label": "6,900,000 EUR" }, { "value": "50000000", "label": "13,000,000 EUR" }]
  const salesmaxEUR = [{ "value": "0", "label": "No Max" }, { "value": "300000", "label": "80,000 EUR" }, { "value": "400000", "label": "100,000 EUR" }, { "value": "500000", "label": "125,000 EUR" }, { "value": "600000", "label": "150,000 EUR" }, { "value": "700000", "label": "180,000 EUR" }, { "value": "800000", "label": "200,000 EUR" }, { "value": "900000", "label": "225,000 EUR" }, { "value": "1000000", "label": "260,000 EUR" }, { "value": "1100000", "label": "285,000 EUR" }, { "value": "1200000", "label": "310,000 EUR" }, { "value": "1300000", "label": "335,000 EUR" }, { "value": "1400000", "label": "360,000 EUR" }, { "value": "1500000", "label": "385,000 EUR" }, { "value": "1600000", "label": "410,000 EUR" }, { "value": "1700000", "label": "430,000 EUR" }, { "value": "1800000", "label": "450,000 EUR" }, { "value": "1900000", "label": "480,000 EUR" }, { "value": "2000000", "label": "500,000 EUR" }, { "value": "2100000", "label": "550,000 EUR" }, { "value": "2200000", "label": "600,000 EUR" }, { "value": "2300000", "label": "630,000 EUR" }, { "value": "2400000", "label": "660,000 EUR" }, { "value": "2500000", "label": "690,000 EUR" }, { "value": "2600000", "label": "710,000 EUR" }, { "value": "2700000", "label": "750,000 EUR" }, { "value": "2800000", "label": "780,000 EUR" }, { "value": "2900000", "label": "810,000 EUR" }, { "value": "3000000", "label": "850,000 EUR" }, { "value": "3250000", "label": "880,000 EUR" }, { "value": "3500000", "label": "910,000 EUR" }, { "value": "3750000", "label": "950,000 EUR" }, { "value": "4000000", "label": "980,000 EUR" }, { "value": "4250000", "label": "1,10,000 EUR" }, { "value": "4500000", "label": "1,250,000 EUR" }, { "value": "5000000", "label": "1,350,000 EUR" }, { "value": "6000000", "label": "1,650,000 EUR" }, { "value": "7000000", "label": "1,900,000 EUR" }, { "value": "8000000", "label": "2,200,000 EUR" }, { "value": "9000000", "label": "2,500,000 EUR" }, { "value": "10000000", "label": "2,700,000 EUR" }, { "value": "25000000", "label": "6,900,000 EUR" }, { "value": "50000000", "label": "13,000,000 EUR" }]

  // USD Lettings min and max

  const lettingsminUSD = [{ "value": "0", "label": "No Min" }, { "value": "20000", "label": "5,000 USD" }, { "value": "30000", "label": "7,500 USD" }, { "value": "40000", "label": "10,000 USD" }, { "value": "50000", "label": "12,500 USD" }, { "value": "60000", "label": "15,000 USD" }, { "value": "70000", "label": "17,500 USD" }, { "value": "80000", "label": "20,000 USD" }, { "value": "90000", "label": "22,500 USD" }, { "value": "100000", "label": "25,000 USD" }, { "value": "110000", "label": "27,500 USD" }, { "value": "120000", "label": "30,000 USD" }, { "value": "130000", "label": "32,500 USD" }, { "value": "140000", "label": "35,000 USD" }, { "value": "150000", "label": "37,500 USD" }, { "value": "160000", "label": "40,000 USD" }, { "value": "170000", "label": "42,500 USD" }, { "value": "180000", "label": "45,000 USD" }, { "value": "190000", "label": "50,000 USD" }, { "value": "200000", "label": "52,500 USD" }, { "value": "225000", "label": "60,000 USD" }, { "value": "250000", "label": "65,000 USD" }, { "value": "275000", "label": "70,000 USD" }, { "value": "300000", "label": "75,000 USD" }, { "value": "350000", "label": "80,000 USD" }, { "value": "400000", "label": "100,000 USD" }, { "value": "500000", "label": "125,000 USD" }, { "value": "750000", "label": "180,000 USD" }, { "value": "1000000", "label": "250,000 USD" }]
  const lettingsmaxUSD = [{ "value": "0", "label": "No Max" }, { "value": "20000", "label": "5,000 USD" }, { "value": "30000", "label": "7,500 USD" }, { "value": "40000", "label": "10,000 USD" }, { "value": "50000", "label": "12,500 USD" }, { "value": "60000", "label": "15,000 USD" }, { "value": "70000", "label": "17,500 USD" }, { "value": "80000", "label": "20,000 USD" }, { "value": "90000", "label": "22,500 USD" }, { "value": "100000", "label": "25,000 USD" }, { "value": "110000", "label": "27,500 USD" }, { "value": "120000", "label": "30,000 USD" }, { "value": "130000", "label": "32,500 USD" }, { "value": "140000", "label": "35,000 USD" }, { "value": "150000", "label": "37,500 USD" }, { "value": "160000", "label": "40,000 USD" }, { "value": "170000", "label": "42,500 USD" }, { "value": "180000", "label": "45,000 USD" }, { "value": "190000", "label": "50,000 USD" }, { "value": "200000", "label": "52,500 USD" }, { "value": "225000", "label": "60,000 USD" }, { "value": "250000", "label": "65,000 USD" }, { "value": "275000", "label": "70,000 USD" }, { "value": "300000", "label": "75,000 USD" }, { "value": "350000", "label": "80,000 USD" }, { "value": "400000", "label": "100,000 USD" }, { "value": "500000", "label": "125,000 USD" }, { "value": "750000", "label": "180,000 USD" }, { "value": "1000000", "label": "250,000 USD" }]

  // Sales min and max
  const salesminUSD = [{ "value": "0", "label": "No Min" }, { "value": "300000", "label": "80,000 USD" }, { "value": "400000", "label": "100,000 USD" }, { "value": "500000", "label": "125,000 USD" }, { "value": "600000", "label": "150,000 USD" }, { "value": "700000", "label": "180,000 USD" }, { "value": "800000", "label": "200,000 USD" }, { "value": "900000", "label": "225,000 USD" }, { "value": "1000000", "label": "260,000 USD" }, { "value": "1100000", "label": "285,000 USD" }, { "value": "1200000", "label": "310,000 USD" }, { "value": "1300000", "label": "335,000 USD" }, { "value": "1400000", "label": "360,000 USD" }, { "value": "1500000", "label": "385,000 USD" }, { "value": "1600000", "label": "410,000 USD" }, { "value": "1700000", "label": "430,000 USD" }, { "value": "1800000", "label": "450,000 USD" }, { "value": "1900000", "label": "480,000 USD" }, { "value": "2000000", "label": "500,000 USD" }, { "value": "2100000", "label": "550,000 USD" }, { "value": "2200000", "label": "600,000 USD" }, { "value": "2300000", "label": "630,000 USD" }, { "value": "2400000", "label": "660,000 USD" }, { "value": "2500000", "label": "690,000 USD" }, { "value": "2600000", "label": "710,000 USD" }, { "value": "2700000", "label": "750,000 USD" }, { "value": "2800000", "label": "780,000 USD" }, { "value": "2900000", "label": "810,000 USD" }, { "value": "3000000", "label": "850,000 USD" }, { "value": "3250000", "label": "880,000 USD" }, { "value": "3500000", "label": "910,000 USD" }, { "value": "3750000", "label": "950,000 USD" }, { "value": "4000000", "label": "980,000 USD" }, { "value": "4250000", "label": "1,10,000 USD" }, { "value": "4500000", "label": "1,250,000 USD" }, { "value": "5000000", "label": "1,350,000 USD" }, { "value": "6000000", "label": "1,650,000 USD" }, { "value": "7000000", "label": "1,900,000 USD" }, { "value": "8000000", "label": "2,200,000 USD" }, { "value": "9000000", "label": "2,500,000 USD" }, { "value": "10000000", "label": "2,700,000 USD" }, { "value": "25000000", "label": "6,900,000 USD" }, { "value": "50000000", "label": "13,000,000 USD" }]
  const salesmaxUSD = [{ "value": "0", "label": "No Max" }, { "value": "300000", "label": "80,000 USD" }, { "value": "400000", "label": "100,000 USD" }, { "value": "500000", "label": "125,000 USD" }, { "value": "600000", "label": "150,000 USD" }, { "value": "700000", "label": "180,000 USD" }, { "value": "800000", "label": "200,000 USD" }, { "value": "900000", "label": "225,000 USD" }, { "value": "1000000", "label": "260,000 USD" }, { "value": "1100000", "label": "285,000 USD" }, { "value": "1200000", "label": "310,000 USD" }, { "value": "1300000", "label": "335,000 USD" }, { "value": "1400000", "label": "360,000 USD" }, { "value": "1500000", "label": "385,000 USD" }, { "value": "1600000", "label": "410,000 USD" }, { "value": "1700000", "label": "430,000 USD" }, { "value": "1800000", "label": "450,000 USD" }, { "value": "1900000", "label": "480,000 USD" }, { "value": "2000000", "label": "500,000 USD" }, { "value": "2100000", "label": "550,000 USD" }, { "value": "2200000", "label": "600,000 USD" }, { "value": "2300000", "label": "630,000 USD" }, { "value": "2400000", "label": "660,000 USD" }, { "value": "2500000", "label": "690,000 USD" }, { "value": "2600000", "label": "710,000 USD" }, { "value": "2700000", "label": "750,000 USD" }, { "value": "2800000", "label": "780,000 USD" }, { "value": "2900000", "label": "810,000 USD" }, { "value": "3000000", "label": "850,000 USD" }, { "value": "3250000", "label": "880,000 USD" }, { "value": "3500000", "label": "910,000 USD" }, { "value": "3750000", "label": "950,000 USD" }, { "value": "4000000", "label": "980,000 USD" }, { "value": "4250000", "label": "1,10,000 USD" }, { "value": "4500000", "label": "1,250,000 USD" }, { "value": "5000000", "label": "1,350,000 USD" }, { "value": "6000000", "label": "1,650,000 USD" }, { "value": "7000000", "label": "1,900,000 USD" }, { "value": "8000000", "label": "2,200,000 USD" }, { "value": "9000000", "label": "2,500,000 USD" }, { "value": "10000000", "label": "2,700,000 USD" }, { "value": "25000000", "label": "6,900,000 USD" }, { "value": "50000000", "label": "13,000,000 USD" }]

  // Property Min Sqft
  const sqftminRange = [{ value: "0", label: "Min Sqft" },
  { value: "100", label: "100" },
  { value: "200", label: "200" },
  { value: "300", label: "300" },
  { value: "400", label: "400" },
  { value: "500", label: "500" },
  { value: "1000", label: "1000" },
  { value: "1500", label: "1500" },
  { value: "2000", label: "2000" },
  { value: "2500", label: "2500" }
  ]
  const sqftmaxRange = [{ value: "0", label: "Max Sqft" },
  { value: "100", label: "100" },
  { value: "200", label: "200" },
  { value: "300", label: "300" },
  { value: "400", label: "400" },
  { value: "500", label: "500" },
  { value: "1000", label: "1000" },
  { value: "1500", label: "1500" },
  { value: "2000", label: "2000" },
  { value: "2500", label: "2500" }
  ]

  const amenitiesList = [
    { label: 'balcony', value: 'balcony', count: 595, isRefined: false },
    { label: 'beach-access', value: 'beach-access', count: 85, isRefined: false },
    { label: 'communal-garden', value: 'communal-garden', count: 184, isRefined: false },
    { label: 'concierge-services', value: 'concierge-services', count: 231, isRefined: false },
    { label: 'conservatory', value: 'conservatory' },
    { label: 'duplex', value: 'duplex' },
    { label: 'garage', value: 'garage' },
    { label: 'garden', value: 'garden' },
    { label: 'golf-course-view', value: 'golf-course-view' },
    { label: 'large-plot', value: 'large-plot' },
    { label: 'maids-room', value: 'maids-room' },
    { label: 'penthouse', value: 'penthouse' },
    { label: 'private-gym', value: 'private-gym' },
    { label: 'roof-terrace', value: 'roof-terrace' },
    { label: 'security', value: 'security' },
    { label: 'shared-gym', value: 'shared-gym' },
    { label: 'shared-pool', value: 'shared-pool' },
    { label: 'swimming-pool', value: 'swimming-pool' }]

  if (!_.isEmpty(props.searchState)) {
    if (!_.isEmpty(props.searchState?.query) && props.searchState?.query !== areaVal) {
      setAreaVal(props.searchState?.query)
    } else if (_.isEmpty(props.searchState?.query) && areaVal !== "Dubai") {
      setAreaVal('Dubai')
    }
  }

  const curr = typeof window !== 'undefined' ? localStorage.getItem('currTo') : null
  const ChangeFunction = () => {
    if (props.type === "lettings") {
      if (curr === 'GBP') {
        setMinPriceList(lettingsminGBP);
        setMaxPriceList(lettingsmaxGBP);
      } else if (curr === 'EUR') {
        setMinPriceList(lettingsminEUR);
        setMaxPriceList(lettingsmaxEUR);
      } else if (curr === 'USD') {
        setMinPriceList(lettingsminUSD);
        setMaxPriceList(lettingsmaxUSD);
      } else {
        setMinPriceList(priceminRangeLettings);
        setMaxPriceList(pricemaxRangeLettings);
      }
    } else {
      if (curr === 'GBP') {
        setMinPriceList(salesminGBP)
        setMaxPriceList(salesmaxGBP)
      } else if (curr === 'EUR') {
        setMinPriceList(salesminEUR)
        setMaxPriceList(salesmaxEUR)
      } else if (curr === 'USD') {
        setMinPriceList(salesminUSD)
        setMaxPriceList(salesmaxUSD)
      } else {
        setMinPriceList(priceminRange)
        setMaxPriceList(pricemaxRange)
      }
    }

  }
  useEffect(() => {
    ChangeFunction()
    setMinPriceVal("")
    setMaxPriceVal("")
  }, [curr]);


  useEffect(() => {

    // setAreaVal(_.upperFirst(pathUri[vi].replace("in-", "").replace(/-/g, " ")))

    const url = typeof window !== 'undefined' ? window.location.href : ''
    let pathUri = url.split("/")
    for (let vi = 1; vi <= pathUri.length; vi++) {
      // check for area
      if (typeof pathUri[vi] === "undefined") {
        continue
      }

      // Property type
      if (pathUri[vi].indexOf("type-") >= 0) {
        setPropertyVal(pathUri[vi].replace("type-", ""))
      }
      // Property type

      // Area
      if ((pathUri[vi].indexOf("in-") == 0) && (pathUri[vi].indexOf("in-london") == -1)) {
        setAreaVal(_.upperFirst(pathUri[vi].replace("in-", "").replace(/-/g, " ")))
      }
      // Area

      // Price
      if (
        pathUri[vi].indexOf("between-aed") >= 0 ||
        pathUri[vi].indexOf("above-aed") >= 0 ||
        pathUri[vi].indexOf("below-aed") >= 0
      ) {
        let priceFilt1 = pathUri[vi].split("above-aed")
        if (priceFilt1[1]) {
          setMinPriceVal(priceFilt1[1])
        }
        let priceFilt2 = pathUri[vi].split("below-aed")
        if (priceFilt2[1]) {
          setMaxPriceVal(priceFilt2[1])
        }
        let priceFilt3 = pathUri[vi].split("between-aed")
        if (priceFilt3[1]) {
          let priceFilt4 = priceFilt3[1].split("-and-aed")
          setMinPriceVal(priceFilt4[0])
          setMaxPriceVal(priceFilt4[1])
        }
      }
      // Price

      // Bedrooms
      if (pathUri[vi].indexOf("-and-more-") >= 0) {
        setBedVal(pathUri[vi].replace("-and-more-bedrooms", ""))
      }
      // Bedrooms 

      // Amenities
      if (pathUri[vi].indexOf("with-") >= 0) {
        // its Amenities
        var amenitiesArrfilt = pathUri[vi].replace("with-", "")
        setAmenities(amenitiesArrfilt.split("-and-"))
      }

      // Size
      if (
        pathUri[vi].indexOf("size-") >= 0 ||
        pathUri[vi].indexOf("abovesize-") >= 0 ||
        pathUri[vi].indexOf("belowsize-") >= 0
      ) {
      
        let priceFilt1 = pathUri[vi].split("abovesize-")
        if (priceFilt1[1]) {
          setSqftMin(priceFilt1[1])
        }
        let priceFilt2 = pathUri[vi].split("belowsize-")
        if (priceFilt2[1]) {
          setSqftMax(priceFilt2[1])
        }
        let priceFilt3 = pathUri[vi].split("size-") 
        if (priceFilt3[1]) {
          let priceFilt4 = priceFilt3[1].split("-to-") 
          setSqftMin(priceFilt4[0])
          setSqftMax(priceFilt4[1])
        }
      }
    }

    $('.more-filter .btn-more').click(function(e){
      setTimeout(() => {
        $('.more-includesold').append($('.filtersearchsold').clone());
      }, 100)
    });
  }, []);

  const resetSearch = (e) => {
    setAmenities([]);
    setSqftMin(0);
    setSqftMax(0);
    var baseTypeUrl = props.locationname + "in-dubai";
    if (props.type == "lettings") {
      baseTypeUrl = props.locationname + "in-dubai";
    }
    navigate(baseTypeUrl)
  }
  const submitSearch = (e) => {
    e.preventDefault();
    var areaValue = $(".searchboxresults .searchVal").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
    if (_.isEmpty(areaValue)) {
      //  areaValue = $(".mobsearchboxresults .searchVal").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
    }

    var bedroomValue = bedVal ? bedVal : $(".bedroom-input input[type='hidden']").val();
    var buildingValue = propertyval ? propertyval : $(".building-dropdown input[type='hidden']").val();
    var amenitiesValues = amenities.length > 0 ? amenities : [];

    let priceUrl = ""
    if (maxpriceVal || minpriceVal) {
      if (minpriceVal && maxpriceVal && minpriceVal != "0" && maxpriceVal != "0") {
        priceUrl = "between-aed" + minpriceVal + "-and-aed" + maxpriceVal
      } else
        if ((minpriceVal == '' || minpriceVal == "0") && maxpriceVal && maxpriceVal != "0") {
          priceUrl = "below-aed" + maxpriceVal
        }
        else if (minpriceVal && (maxpriceVal == '' || maxpriceVal == "0") && minpriceVal != "0") {
          priceUrl = "above-aed" + minpriceVal
        }

    }
    var baseTypeUrl = (areaValue ? props.locationname + "in-" + areaValue + "/" : props.locationname);
    if (props.type == "lettings") {
      baseTypeUrl = (areaValue ?  props.locationname + "in-" + areaValue + "/" : props.locationname);
    }
    let sizePath = ''; 
    // Size
    if (parseInt(sqftMin) > 0 || parseInt(sqftMax) > 0) {
      if (parseInt(sqftMin) > 0 && parseInt(sqftMax) > 0) {
        sizePath = "size-" + sqftMin + "-to-" + sqftMax + '/'
      } else if (parseInt(sqftMax) > 0) {
        sizePath = "belowsize-" + sqftMax + '/'
      } else if (parseInt(sqftMin) > 0) {
        sizePath = "abovesize-" + sqftMin + '/'
      }
    }

    var searchFilterResults = (
      baseTypeUrl +
      (buildingValue ? "type-" + buildingValue + "/" : '') +
      (bedroomValue && bedroomValue != "0" ? bedroomValue + "-and-more-bedrooms/" : '') +
      (priceUrl ? priceUrl + "/" : '') +
      ((amenitiesValues.length > 0) ? `with-${amenitiesValues.map(encodeURIComponent).join('-and-')}/` : '') +
      sizePath

    );

    navigate(searchFilterResults)
  }
  // Min price
  const onChangeMinPrice = (e) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('minPrice', e.label)
      if(maxpriceVal == 0){
        localStorage.setItem('maxPrice', 0)
      }
    }
    setSelectedMinPriceValue(e.value);
    if (props.type === "lettings") {
      var maxPrice = maxPriceList.filter(c => (c.value === "0" || parseInt(c.value) > parseInt(e.value)));
      setMaxPriceList(maxPrice);
    } else {
      var maxPrice = maxPriceList.filter(c => (c.value === "0" || parseInt(c.value) > parseInt(e.value)));
      setMaxPriceList(maxPrice);
    }
  }
  // Min price

  // Max Price
  const onChangeMaxPrice = (e) => {
    if (typeof window !== 'undefined') { 
      
      localStorage.setItem('maxPrice', e.label)
      if(minpriceVal == 0){
        localStorage.setItem('minPrice', 0)
      }
    }
    setSelectedMaxPriceValue(e.value);
    if (props.type === "lettings") {
      var minPrice = minPriceList.filter(c => (c.value === "0" || parseInt(c.value) < parseInt(e.value)));
      setMinPriceList(minPrice);
    } else {
      var minPrice = minPriceList.filter(c => (c.value === "0" || parseInt(c.value) < parseInt(e.value)));
      setMinPriceList(minPrice);
    }
  }
  // Max Price

  // Filters
  const advancedFilterClose = (e) => {
    $(".dropdown-exp").toggleClass("active");
    setFilterOpen(false)
  }
  // Filters
  const clickHandle = (e) => {
    const li = e.target.closest('li');
    li.closest('ul').querySelectorAll('li').forEach(item => {
      if (item !== li) {
        item.classList.remove('active');
      }
    })
    e.target.closest('li').classList.toggle('active');
  }

  var bedValue = { label: "Beds", value: "" }
  if (bedVal && bedVal != '0') {
    bedValue = { label: bedVal ? options.find(obj => obj.value === bedVal).label : "Beds", value: bedVal ? bedVal : "" }
  } else if (bedVal && bedVal == '0') {
    bedValue = { label: "Any", value: "" }
  }

  var propertyValue = { label: "All", value: "" }
  if (propertyval == null) {
    propertyValue = { label: "Property Type", value: "" }
  } else if (propertyval) {
    propertyValue = { label: propertyval ? _.startCase(_.toLower(propertyval)) : "Property Type", value: propertyval ? propertyval : "" }
  }

  let minSqftRange = sqftminRange;
  if (parseInt(sqftMax) > 0) {
    minSqftRange = sqftminRange.filter((x) => parseInt(x.value) < parseInt(sqftMax))
  }

  let maxSqftRange = sqftmaxRange;
  if (parseInt(sqftMin) > 0) {
    maxSqftRange = sqftmaxRange.filter((x) => x.value == "0" || parseInt(x.value) > parseInt(sqftMin))
  } 
 
  return (
    <React.Fragment>
      <Form onSubmit={(e) => { submitSearch(e) }}>
        <div className="filter-group">
          <div className="filter-search">
            <div className="filter-search-field filter-search-area searchboxresults">
              <SearchResultInputBox areaVal={areaVal} placeHolder={`Building, Area or Project name`} />
            </div>
          </div>
          <div className="filter-select">
            <div className="filter-select-field building-field">
              <Select
                name="building"
                options={propertytypelist}
                value={propertytypelist.find(obj => obj.value === propertyval)}
                placeholder="Property Type"
                classNamePrefix={"select-opt"}
                onChange={e => setPropertyVal(e.value)}
                isSearchable={false}
                styles={styles}
              />
            </div>

            <div className="filter-select-field price-field salesprice-field">
              <ul className="filter-list">
                <li className="price-filter-dropdown">
                  <button type="button" onClick={clickHandle}>Price Range</button>
                  <div className="filter-dropdown">
                    <div className="select">
                      <Select
                        name="minprice"
                        options={minPriceList}
                        value={minPriceList.find(obj => obj.value === minpriceVal && obj.label === minpricelabel)}
                        isSearchable={false}
                        placeholder="Min Price"
                        classNamePrefix={"select-opt"}
                        onChange={e => { onChangeMinPrice(e); setMinPriceVal(e.value); setMinpricelabel(e.label) }}
                        styles={styles}
                      />
                    </div>
                    <div className="select">
                      <Select
                        name="maxprice"
                        options={maxPriceList}
                        value={maxPriceList.find(obj => obj.value === maxpriceVal && obj.label === maxpricelabel)}
                        isSearchable={false}
                        placeholder="Max Price"
                        classNamePrefix={"select-opt"}
                        onChange={e => { onChangeMaxPrice(e); setMaxPriceVal(e.value); setMaxpricelabel(e.label) }}
                        styles={styles}
                      />
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="filter-select-field bedroom-field">
              <Select
                name="beds"
                options={options}
                value={bedValue}
                placeholder="Beds"
                classNamePrefix={"bedroom-input select-opt"}
                styles={styles}
                onChange={e => setBedVal(e.value)}
                isSearchable={false}
              />
            </div>
            <div className="filter-select-field more-filter">
              <button type="button" class="btn btn-select btn-more" onClick={() => { setFilterOpen(true) }}>More Filters <i class="filter-icon"></i></button>
            </div>

          </div>
          <div className="search-filter-button ">
            <button type="submit" class="btn btn-secondary search-button">Search</button>
          </div>
        </div>
      </Form>
      {filterOpen &&
        <section className={`filter-search-overlay ${filterOpen ? 'active-filter' : ''}`}>
          <div className="filter-close">

            <span className="close-menu" onClick={() => { advancedFilterClose() }}><i className="close-icon"></i></span>
          </div>

          <div className="filter-wrapper">
            <Container>
              <Row className="justify-content-center">
                <Col xl={6} lg={8} md={10}>
                  <div className="h3">Advanced Filters</div>
                  <div className="filter-select">
                    <div className="filter-select-field">
                      <Select
                        name="building"
                        options={propertytypelist}
                        value={propertytypelist.find(obj => obj.value === propertyval)}
                        placeholder="Property Type"
                        classNamePrefix={"select-opt"}
                        onChange={e => setPropertyVal(e.value)}
                        isSearchable={false}
                        styles={styles}
                      />
                    </div>

                    <div className="filter-select-field price-field">
                      <ul className="filter-list">
                        <li className="price-filter-dropdown">
                          <button type="button" onClick={clickHandle}>Price Range</button>
                          <div className="filter-dropdown">
                            <div className="select">
                              <Select
                                name="minprice"
                                options={minPriceList}
                                value={minPriceList.find(obj => obj.value === minpriceVal && obj.label === minpricelabel)}
                                isSearchable={false}
                                placeholder="Min Price"
                                classNamePrefix={"select-opt"}
                                onChange={e => { onChangeMinPrice(e); setMinPriceVal(e.value); setMinpricelabel(e.label) }}
                                styles={styles}
                              />
                            </div>
                            <div className="select">
                              <Select
                                name="maxprice"
                                options={maxPriceList}
                                value={maxPriceList.find(obj => obj.value === maxpriceVal && obj.label === maxpricelabel)}
                                isSearchable={false}
                                placeholder="Max Price"
                                classNamePrefix={"select-opt"}
                                onChange={e => { onChangeMaxPrice(e); setMaxPriceVal(e.value); setMaxpricelabel(e.label) }}
                                styles={styles}
                              />
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div className="filter-select-field bedroom-field">
                      <Select
                        name="beds"
                        options={options}
                        value={bedValue}
                        placeholder="Beds"
                        classNamePrefix={"bedroom-input select-opt"}
                        styles={styles}
                        onChange={e => setBedVal(e.value)}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="more-includesold"></div>

                  <CustomRefinementList
                    // attribute="amenities"
                    // limit={100}
                    // operator={"and"}
                    amenitiesList={amenitiesList}
                    amenities={amenities}
                    setAmenities={setAmenities}
                  />
                  <div className="amenities-property-size my-3">
                    <div className="refine-heading">Property Size</div>
                    <ul className="list-inline d-flex justify-content-between">
                      <li className="list-inline-item">
                        <Form.Group className="mb-0">
                          <div className="select-group">
                            <Select
                              name="min_size"
                              options={minSqftRange}
                              defaultValue={minSqftRange.find(obj => obj.value === sqftMin)}
                              classNamePrefix={"amenitiespopup_select select-opt"}
                              placeholder="Min Sqft"
                              onChange={(e) => setSqftMin(e.value)}
                              isSearchable={false}
                              styles={styles}
                            />
                          </div>
                        </Form.Group>
                      </li>
                      <li className="list-inline-item">
                      
                        <Select
                          name="max_size"
                          options={maxSqftRange} 
                          defaultValue={maxSqftRange.find(obj => obj.value === sqftMax)}
                          classNamePrefix={"amenitiespopup_select select-opt"}
                          placeholder="Max Sqft"
                          onChange={(e) => setSqftMax(e.value)}
                          isSearchable={false}
                          styles={styles}
                        />
                      </li>
                    </ul>
                  </div>
                  <div className="refine-buttons">
                    <div className="d-flex justify-content-between">
                      <a  href="javascript:void(0)" className="btn btn-outline btn-outline--white"  onClick={(e) => {
                        resetSearch(e)
                        advancedFilterClose()  
                      }}><span>Clear Filters</span></a>
                      <a href="javascript:void(0)" onClick={(e) => {
                        submitSearch(e)
                        advancedFilterClose()  
                      }} className="btn btn-secondary"><span>Search</span></a>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </section>
      }

    </React.Fragment >
  );
};

export default SearchFilter;